const SS_KEY_PREFIX = 'sm_bubble_closed_';

function init() {
    const bubble = document.querySelector('.c-sm-bubble');
    if (!bubble) return;

    const balloon = bubble.querySelector('.c-sm-bubble__balloon');
    const closeBtn = bubble.querySelector('.js-speech-bubble-close');
    const id = bubble.dataset.missionId;

    if (id && sessionStorage.getItem(SS_KEY_PREFIX + id)) {
        balloon.classList.add('is-hidden');
    }

    closeBtn?.addEventListener('click', () => {
        balloon.classList.add('is-hidden');
        if (id) sessionStorage.setItem(SS_KEY_PREFIX + id, '1');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
